import React, { useEffect, useRef, useState } from "react";
import { Form, Select, Button, DatePicker, Radio, Input } from "antd";
import {
  aadharPattern,
  panPattern,
  pincodePattern,
  mobilePattern,
  emailPattern,
  filterOption,
  dispatchtoast,
  PortalName,
} from "../../Utils";
import {
  getCityAuthless,
  getCountryAuthless,
  getStateAuthLess,
  getmemberPackages,
  getmemberTypeAuthless,
  userRegister,
} from "../../ApiServices/Apifun";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import CommonInput from "../../Common/CommonInput";
import { Images } from "../../Controller";
import AuthLayout from "../../Common/CommoinAuthscreen";
const Register = () => {
  const formRef = useRef();
  const [form] = Form.useForm();
  const [membercustomPayload, setCustomMemberPayload] = useState({});
  const [country, setCountry] = useState([]);
  const [check, setcheck] = useState(false);
  const [state, setState] = useState([]);
  const [city, setCity] = useState([]);
  const [packages, setPackages] = useState([]);
  //   const [selectedMember, setSelectedMember] = useState(null);
  const [memberType, setMemberType] = useState([]);
  const profiledetail = useSelector((state) => state.B2B.profileDetail);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    // dispatch(setselectedTab("15"));
    // if (profiledetail.member_type === "Retailer") {
    //   navigate("/dashboard");
    // } else {
    getCountryAuthless()
      .then((res) => {
        setCountry(
          res.countries.map((i, index) => {
            return {
              label: i.name,
              value: i.id,
              key: i.id,
            };
          }),
        );
      })
      .catch((err) => console.log(err));
    getmemberTypeAuthless()
      .then((res) => {
        setMemberType(
          res.data.map((i) => {
            return {
              label: i.type,
              value: i.id,
              key: i.id,
            };
          }),
        );
      })
      .catch((err) => console.log(err));
    // }
  }, []);
  // const handleGetPackage = (val) => {
  //   setSelectedMember(val);
  //   setCustomMemberPayload({});
  //   getmemberPackages({ member_type: val })
  //     .then((res) => setPackages(res.packages))
  //     .catch((err) => console.log(err));
  // };
  const handleGetState = (val) => {
    const payload = {
      country_id: val,
    };
    getStateAuthLess(payload)
      .then((res) => {
        setState(
          res.states.map((i, index) => {
            return {
              label: i.name,
              value: i.id,
              key: i.id,
            };
          }),
        );
      })
      .catch((err) => console.log(err));
  };
  const handleGetCity = (val) => {
    const payload = {
      state_id: val,
    };
    getCityAuthless(payload)
      .then((res) => {
        setCity(
          res.cities.map((i, index) => {
            return {
              label: i.name,
              value: i.id,
              key: i.id,
            };
          }),
        );
      })
      .catch((err) => console.log(err));
  };
  const handleAutoFill = (e) => {
    form.getFieldValue(country);
    setcheck(e.target.checked);
    formRef.current.setFieldsValue({
      business_country: form.getFieldValue("country"),
      business_state: form.getFieldValue("state"),
      business_city: form.getFieldValue("city"),
      business_zip: form.getFieldValue("zip"),
    });
  };
  const handleFinish = (val) => {
    let data = { ...val };
    data.pan = data.pan.toUpperCase();
    data.dob = dayjs(data.dob).format("YYYY-MM-DD");
    const formdata = new FormData();
    formdata.append("is_same_address", check ? 1 : 0);
    // formdata.append("member_type", selectedMember);
    // Object.entries(membercustomPayload).forEach(([key, val]) =>
    //   formdata.append(key, val)
    // );
    Object.entries(data).forEach(([key, val]) => formdata.append(key, val));
    userRegister(formdata)
      .then((res) => {
        if (res.status) {
          dispatchtoast(res.message);
          navigate("/");
        }
      })
      .catch((err) => console.log(err));
  };
  return (
    <>
      <AuthLayout
        title="Create Account"
        subtitle="Fill in your details to register"
        maxWidth="max-w-[1400px]"
      >
        <Form
          form={form}
          ref={formRef}
          className="authForm"
          name="basic"
          initialValues={{
            remember: true,
          }}
          onFinishFailed={(err) => console.log(err)}
          onFinish={(val) => handleFinish(val)}
        >
          {/* <p className="text-md text-primary font-semibold">Add Member</p> */}
          <p className="mt-4 mb-6 text-white text-xl font-semibold">
            Member Details
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
            {" "}
            <Form.Item
              name={`first_name`}
              label={"First Name"}
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: true,
                  message: "Enter First Name!",
                },
                {
                  whitespace: true,
                  message: "Field cannot contain only blank spaces",
                },
              ]}
            >
              <CommonInput
                placeholder="Enter Your First Name"
                name="first_name"
                className="authInput"
              />
            </Form.Item>
            <Form.Item
              name={`last_name`}
              label={"Last Name"}
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: true,
                  message: "Enter Last Name!",
                },
                {
                  whitespace: true,
                  message: "Field cannot contain only blank spaces",
                },
              ]}
            >
              <CommonInput
                placeholder="Enter Your Last Name"
                name="last_name"
                className="authInput"
              />
            </Form.Item>{" "}
            <Form.Item
              name={`dob`}
              label={"Date Of Birth"}
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: true,
                  message: "Enter Date Of Birth!",
                },
              ]}
            >
              <DatePicker
                popupClassName="bottom-calendar"
                className="w-full authDatePicker"
                onChange={() => {}}
                placement="bottomLeft"
                placeholder="Enter DOB"
              />
            </Form.Item>
            <Form.Item
              labelCol={{ span: 24 }}
              label="Gender"
              name={"gender"}
              rules={[
                {
                  required: true,
                  message: "Select Gender!",
                },
              ]}
            >
              <div className="radio-group text-white">
                {" "}
                <Radio.Group name="gender">
                  <Radio value="0"> Male </Radio>
                  <Radio value="1"> Female </Radio>
                </Radio.Group>
              </div>
            </Form.Item>
            <Form.Item
              name={`aadhar`}
              label={"Aadhar Number"}
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: true,
                  message: "Enter Aadhar Number!",
                },
                {
                  pattern: aadharPattern,
                  message: "Invalid Aadhaar card number format!",
                },
                {
                  whitespace: true,
                  message: "Field cannot contain only blank spaces",
                },
              ]}
            >
              <CommonInput
                placeholder="Enter Your Aadhar Number"
                name="aadhar"
                className="authInput"
              />
            </Form.Item>
            <Form.Item
              name={`pan`}
              label={"Pan Card"}
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: true,
                  message: "Enter Pan!",
                },
                {
                  pattern: panPattern,
                  message: "Invalid PAN format!",
                },
                {
                  whitespace: true,
                  message: "Field cannot contain only blank spaces",
                },
              ]}
            >
              <CommonInput
                placeholder="Enter Pan"
                name="pan"
                className="authInput"
              />
            </Form.Item>
            <Form.Item
              name={`mobile`}
              label={"Mobile"}
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: true,
                  message: "Enter your Mobile Number!",
                },
                {
                  pattern: mobilePattern,
                  message: "Invalid mobile number!",
                },
                {
                  whitespace: true,
                  message: "Field cannot contain only blank spaces",
                },
              ]}
            >
              <CommonInput
                placeholder="Enter Your Mobile"
                name="mobile"
                className="authInput"
              />
            </Form.Item>{" "}
            <Form.Item
              name={`email`}
              label={"Email"}
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: true,
                  message: "Enter your Email!",
                },
                {
                  pattern: emailPattern,
                  message: "Enter Valid Email!",
                },
                {
                  whitespace: true,
                  message: "Field cannot contain only blank spaces",
                },
              ]}
            >
              <CommonInput
                placeholder="Enter Your Email "
                name="email"
                className="authInput"
              />
            </Form.Item>{" "}
            <Form.Item
              name={`address`}
              label={"Address"}
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: true,
                  message: "Enter Address!",
                },
                {
                  whitespace: true,
                  message: "Field cannot contain only blank spaces",
                },
              ]}
            >
              <Input.TextArea
                placeholder="Enter Your Address"
                name="address"
                className="authInput"
              />
            </Form.Item>{" "}
            <Form.Item
              name={`country`}
              label={"Country"}
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: true,
                  message: "Select  country!",
                },
              ]}
            >
              <Select
                placeholder="--Select Country--"
                showSearch
                onChange={(val) => handleGetState(val)}
                className="authSelect"
                options={country}
              />
            </Form.Item>{" "}
            <Form.Item
              name={`state`}
              label={"State"}
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: true,
                  message: "Select state!",
                },
              ]}
            >
              <Select
                placeholder="--Select State--"
                showSearch
                filterOption={filterOption}
                onChange={(val) => handleGetCity(val)}
                className="authSelect"
                options={state}
              />
            </Form.Item>
            <Form.Item
              name={`city`}
              label={"City"}
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: true,
                  message: "Select city!",
                },
              ]}
            >
              <Select
                placeholder="--Select City--"
                showSearch
                filterOption={filterOption}
                className="authSelect"
                options={city}
              />
            </Form.Item>
            <Form.Item
              name={`zip`}
              label={"Zip"}
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: true,
                  message: "Enter PinCode!",
                },
                {
                  pattern: pincodePattern,
                  message: "Invalid PIN code format!",
                },
                {
                  whitespace: true,
                  message: "Field cannot contain only blank spaces",
                },
              ]}
            >
              <CommonInput
                placeholder="Enter Your Pin Code"
                name="zip"
                className="authInput"
              />
            </Form.Item>
          </div>
          <p className="mt-8 mb-6 text-white text-xl font-semibold">
            Business Details
          </p>
          <div className="mt-2 mb-6 flex items-center gap-3">
            <input
              checked={check}
              onChange={(e) => handleAutoFill(e)}
              type="checkbox"
              className="accent-[#f89522] h-4 w-4"
            />

            <p className="text-white/80 text-sm">
              Is business address same as member address?
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
            <Form.Item
              name={`business_name`}
              label={"Buisness Name"}
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: true,
                  message: "Enter Business Name!",
                },
                {
                  whitespace: true,
                  message: "Field cannot contain only blank spaces",
                },
              ]}
            >
              <CommonInput
                placeholder="Enter Your Business Name"
                name="business_name"
                className="authInput"
              />
            </Form.Item>
            <Form.Item
              name={`business_address`}
              label={"Business Address"}
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: true,
                  message: "Enter Business Address!",
                },
                {
                  whitespace: true,
                  message: "Field cannot contain only blank spaces",
                },
              ]}
            >
              <CommonInput
                placeholder="Enter Your Business Address"
                name="business_address"
                className="authInput"
              />
            </Form.Item>{" "}
            <Form.Item
              name={`business_country`}
              label={"Business Country"}
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: true,
                  message: "Select country!",
                },
              ]}
            >
              <Select
                placeholder="--Select Country--"
                showSearch
                filterOption={filterOption}
                allowClear
                onChange={(val) => handleGetState(val)}
                className="authSelect"
                options={country}
              />
            </Form.Item>{" "}
            <Form.Item
              name={`business_state`}
              label={"Business State"}
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: true,
                  message: "Select  state!",
                },
              ]}
            >
              <Select
                placeholder="--Select State--"
                showSearch
                filterOption={filterOption}
                onChange={(val) => handleGetCity(val)}
                className="authSelect"
                options={state}
              />
            </Form.Item>{" "}
            <Form.Item
              name={`business_city`}
              label={"Business City"}
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: true,
                  message: "Select any one city!",
                },
              ]}
            >
              <Select
                placeholder="--Select City--"
                showSearch
                filterOption={filterOption}
                className="authSelect"
                options={city}
              />
            </Form.Item>{" "}
            <Form.Item
              name={`business_zip`}
              label={"Business Zip "}
              labelCol={{ span: 24 }}
              rules={[
                {
                  required: true,
                  message: "Enter Zip!",
                },
                {
                  pattern: pincodePattern,
                  message: "Invalid PIN code format!",
                },
                {
                  whitespace: true,
                  message: "Field cannot contain only blank spaces",
                },
              ]}
            >
              <CommonInput
                placeholder="Business Zip Code"
                name="business_zip"
                className="authInput"
              />
            </Form.Item>
            <div className="w-full">
              <p className="mt-8 mb-6 text-white text-base font-semibold">
                Member Detail
              </p>
              <Form.Item
                label={"Member Type "}
                labelCol={{ span: 24 }}
                rules={[
                  {
                    required: true,
                    message: "Select member type!",
                  },
                ]}
                name={"member_type"}
              >
                <Select
                  placeholder="Select Member Type"
                  showSearch
                  filterOption={filterOption}
                  className="authSelect"
                  options={memberType}
                />
              </Form.Item>
            </div>
          </div>
          <div className="mt-8">
            <Form.Item className="mb-0">
              <Button
                htmlType="submit"
                block
                style={{
                  background:
                    "#f89522",
                  border: "none",
                  color: "#fff",
                  borderRadius: "14px",
                  height: "50px",
                  fontWeight: 600,
                  letterSpacing: "1px",
                }}
              >
                CREATE ACCOUNT
              </Button>
            </Form.Item>
          </div>
        </Form>
      </AuthLayout>
    </>
  );
};

export default Register;
